import React from "react";
import { css } from "@emotion/react";

import theme from "../../../theme";

type Props = {
    children: React.ReactNode,
    setModalElement?: (ref: any) => void,
    modalAttributes?: any[],
    className?: string,
}
const DefaultContainer = ({ children, setModalElement, modalAttributes, className = "" }: Props) => (
    <div className={className} css={style} ref={setModalElement} {...modalAttributes}>
        {children}
    </div>
);

export default DefaultContainer;

const style = css`
    ${theme.mixins.modal.niceContainerBase};
`;
